// set variables using different element classes and attributes to pick up customisable settings
let set_items_slick = false;
if (document.querySelector('.product__setItems')?.classList.contains('slick')) {
  set_items_slick = true;
}
let desktop_media = '';
if (document.querySelector('.product__media-gallery').classList.contains('remove-desktop')) {
  desktop_media = 'stacked';
} else {
  desktop_media = 'carousel';
}
let thumbnail_nav = 'all';
if (document.querySelector('.product__media-nav').classList.contains('remove-device')) {
  thumbnail_nav = 'remove-device';
} else if (document.querySelector('.product__media-nav').classList.contains('remove-mobile')) {
  thumbnail_nav = 'remove-mobile';
} else if (!document.querySelector('.product__media-nav')) {
  thumbnail_nav = 'none';
}
let thumbnails_slick_nav = document.querySelector('.product__media-nav');
let thumbnails_mobile = thumbnails_slick_nav.dataset.thumbnailsMobile;
let thumbnails_device = thumbnails_slick_nav.dataset.thumbnailsDevice;
let thumbnails_desktop = thumbnails_slick_nav.dataset.thumbnailsDesktop;

// on load slicks set item cards if enabled
if (set_items_slick == true) {
  slickSetitems();
}

// replaces unnecessary size chart links with plain text so that attention isn't drawn away from the drawer button
let sizechartlink = document.querySelectorAll('.product__description-sizing a[href*="https://hopelesslingerie.com/pages/size-chart"]');
if (sizechartlink.length > 0) {
  sizechartlink.forEach(item => {
		item.outerHTML="size guide";
  });
};

// on load calls a gallery slick function depending on the screen size and nav options chosen
if ($(window).width() < 750) {
  if (thumbnail_nav == 'all') {
    thumbnailsNav();
    gallerySlickNav();
  } else {
    gallerySlick();
  }
} else if ($(window).width() < 990) {
  if (thumbnail_nav != 'remove-device') {
    thumbnailsNav();
    gallerySlickNav();
  } else {
    gallerySlick();
  }
} else if (desktop_media == 'carousel') {
  thumbnailsNav();
  gallerySlickNav();
}

window.addEventListener("resize", (event) => {
  $('.product__media-list.slick')[0].slick.refresh();
  $('.product__description-sections.slick')[0].slick.refresh();
  // if desktop gallery isn't set to carousel (and therefore gallery isn't slicked on load unless using a device), slicks the gallery if the window is resized below desktop breakpoint
  if (desktop_media != 'carousel') {
    if ($(window).width() < 750) {
      if (thumbnail_nav == 'all') {
        thumbnailsNav();
        $('.product__media-nav.slick')[0].slick.refresh();
      }
    } else if ($(window).width() < 990) {
      if (thumbnail_nav != 'remove-device') {
        thumbnailsNav();
        $('.product__media-nav.slick')[0].slick.refresh();
      }
    }
  }
});

function thumbnailsNav() {
  // Change the main image whenever a thumbnail button is activated
  $('.thumbnails-nav').on('init', function(e, slider) {
    $(slider.$slides.find('.thumbnail-button')).each(function(index) {
      $(this).on('click', function() {
        // Move aria-current="true" to this button
        $(slider.$slides.find('.thumbnail-button').removeAttr('aria-current'));
        $(this).attr('aria-current', true);
  
        // Change the main image to match this thumbnail button
        var index = $(this).closest('.slick-slide').data('slick-index');
        $('.thumbnails-master').slick('slickGoTo', index);
      });
    });
    $('.thumbnails-nav').delay(2000).addClass('loaded');
  });

  // Update the thumbnail slider when the user changes the main slider directly.
  $('.thumbnails-master').on('beforeChange', function(e, slider, currentSlide, nextSlide) {
    // Remove aria-current from the last selected thumbnail image button
    $('.thumbnails-nav.slick-initialized .thumbnail-button[aria-current="true"]').removeAttr('aria-current');
    
    // Select the thumbnail image button that goes with this main image. Most importantly, this updates Slick's internal state to be consistent with the visual change.
    $('.thumbnails-nav.slick-initialized').slick('slickGoTo', nextSlide);
  
    // Add aria-current="true" to the correct thumbnail image button to convey to screen readers that it's active.
    $('.thumbnails-nav.slick-initialized .thumbnail-button:eq(' + nextSlide + ')').attr('aria-current', true);
  });
}

// Function defined for turning gallery into a carousel WITHOUT thumbnail nav, called on document ready or window resize depending on the gallery options that have been chosen
function gallerySlick() {
  $('.product__media-list.slick').slick({
    lazyLoad: 'ondemand',
    speed: 700,
    easing: 'linear',
    arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous Slide"><svg width="100%" height="100%" viewBox="0 0 20 20"><g transform="matrix(-0.00561986,-0.00561986,0.00561986,-0.00561986,7.09528,27.8618)"><path d="M510.38,1027.25L2151.09,1027.25L2151.09,2667.96" fill="none" stroke="currentColor" stroke-width="80"/></g></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next Slide"><svg width="100%" height="100%" viewBox="0 0 20 20"><g transform="matrix(0.00561986,0.00561986,-0.00561986,0.00561986,12.9047,-7.86183)"><path d="M510.38,1027.25L2151.09,1027.25L2151.09,2667.96"  fill="none" stroke="currentColor" stroke-width="80"/></g></svg></button>',
    instructionsText: 'This carousel shows one large product image at a time. Use the Previous and Next buttons to move between images.',
    regionLabel: 'main image carousel'
  });
}

// Function defined for turning gallery into a carousel WITH thumbnail nav, called on document ready or window resize depending on the gallery options that have been chosen
function gallerySlickNav() {
  $('.product__media-list.slick').slick({
    lazyLoad: 'ondemand',
    speed: 700,
    easing: 'linear',
    arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous Slide"><svg width="100%" height="100%" viewBox="0 0 20 20"><g transform="matrix(-0.00561986,-0.00561986,0.00561986,-0.00561986,7.09528,27.8618)"><path d="M510.38,1027.25L2151.09,1027.25L2151.09,2667.96" fill="none" stroke="currentColor" stroke-width="80"/></g></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next Slide"><svg width="100%" height="100%" viewBox="0 0 20 20"><g transform="matrix(0.00561986,0.00561986,-0.00561986,0.00561986,12.9047,-7.86183)"><path d="M510.38,1027.25L2151.09,1027.25L2151.09,2667.96"  fill="none" stroke="currentColor" stroke-width="80"/></g></svg></button>',
    asNavFor: '.product__media-nav',
    instructionsText: 'This carousel shows one large product image at a time. Use the Previous and Next buttons to move between images, or use the thumbnails carousel after it to select a specific image to display here.',
    regionLabel: 'main image carousel'
  });
  
  $('.product__media-nav.slick').slick({
    speed: 700,
    easing: 'linear',
    arrows: true,
    dots: false,
    infinite: false,
    draggable: false,
    slidesToShow: parseInt(thumbnails_desktop, 10),
    slidesToScroll: 1,
    adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous Slide"><svg width="100%" height="100%" viewBox="0 0 20 20"><g transform="matrix(-0.00561986,-0.00561986,0.00561986,-0.00561986,7.09528,27.8618)"><path d="M510.38,1027.25L2151.09,1027.25L2151.09,2667.96" fill="none" stroke="currentColor" stroke-width="80"/></g></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next Slide"><svg width="100%" height="100%" viewBox="0 0 20 20"><g transform="matrix(0.00561986,0.00561986,-0.00561986,0.00561986,12.9047,-7.86183)"><path d="M510.38,1027.25L2151.09,1027.25L2151.09,2667.96"  fill="none" stroke="currentColor" stroke-width="80"/></g></svg></button>',
    asNavFor: '.product__media-list',
    instructionsText: 'This carousel contains small thumbnails, selecting a thumbnail will change the main image visible in the carousel before it. Use the Previous and Next buttons to cycle through all the thumbnails, use Enter to select.',
    regionLabel: 'thumbnails carousel',
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: parseInt(thumbnails_device, 10)
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: parseInt(thumbnails_mobile, 10)
        }
      }
    ]
  });
}

// Runs slick on product description so that sections can be shown as fading slides
// Loops through description blocks and adds an incremental class to identify them then initialises a slick slider (prevents them from controlling each other)
var descnavNum = 0
$('.product__description-nav').each(function(i, obj) {
  descnavNum++;
  $(this).addClass('descnav' + descnavNum);
});
var descNum = 0
$('.product__description-sections.slick').each(function(i, obj) {
  descNum++;
  $(this).addClass('desc' + descNum);
  $(this).slick({
    lazyLoad: 'ondemand',
    speed: 500,
    easing: 'linear',
    fade: true,
    infinite: false,
    draggable: false,
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    appendDots: '.product__description-nav.descnav' + descNum,
    customPaging: function(slider, i) { 
      return '<button class="tab h2">' + $(slider.$slides[i]).find('.product-single__description').attr('title') + '</button>';
    }
  });
});

//Runs slick on set item cards if carousel is enabled
function slickSetitems() {
  // Loops through the product cards and creates a slider for each
  var setcard = 0;
  $('.product__setItems.slick .media.slick').each(function(i, obj) {
    setcard++
    $(this).slick({
      lazyLoad: 'ondemand',              
      speed: 700,
      easing: 'linear',
      adaptiveHeight: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      prevArrow: '<button type="button" class="slick-prev visually-hidden-device" aria-label="Previous Slide"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" fill="currentColor"></path></svg></button>',
      nextArrow: '<button type="button" class="slick-next visually-hidden-device" aria-label="Next Slide"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" fill="currentColor" transform="translate(100, 100) rotate(180)"></path></svg></button>'
    });
  });
}

// When a fabric radio input is selected, adds the name of the fabric to a display field and scrolls the page to top/moves carousel to the variant image (image change handled by variant-selects in global.js)
$('body').on('click', '.product-form__input.options-Fabric input[type="radio"]', function () {
  var selectedFabric = $(this).val();
  var mediaIndex = $(this).data("media-index");
  var slideIndex = 0;

  // Checks variable set in main.product.liquid that references variant images setting, and sets index to the value stored in the input data if the variant image is shown in the gallery rather than the first slide
  if (display_variant_images == true) {
    var slideIndex = mediaIndex;
  }

  $('.variant-fabric-selected').text(selectedFabric);
  $('.product__media-list.slick').slick('slickGoTo', slideIndex);

  if ($('.product__media-nav').css('display') != 'none') {
      $('.product__media-nav.slick').slick('slickGoTo', slideIndex);

    setTimeout(() => {
      var selectedID = $('.product__media-list .product__media-item--variant.is-active').attr("data-media-id");
      var activeThumbnail = $('.product__media-nav .product__media-item--variant[data-media-id='+selectedID+']');
      $('.product__media-nav .product__media-item--variant').removeClass('is-active');
      activeThumbnail.addClass('is-active');
    }, 100);
  }
});